import { BusinessType } from '../constants/businessType';

const isResellerSignupParam = 'is_reseller_signup';

const indestinationParam = 'indestination';
/**
 * Used to store form prefill data
 */
export class PrefillData {
    //Add other prefill data here
    businessType: string = BusinessType.OPERATOR;

    /**
     * Function used to populate field from url params
     * @param url url of the current page to retrieve params
     */
    prefillWithParams(url: URL): void {
        this.businessType = this.selectReseller(url);
    }

    private selectReseller(url: URL): string {
        return url.searchParams.get(isResellerSignupParam) == '1' || url.searchParams.get(indestinationParam)
            ? BusinessType.RESELLER
            : BusinessType.OPERATOR;
    }
}
